import moment from "moment";
import React from "react";

export const forecastPeriodOptions = [
    {
        label: (
            <div
                className=" text-slate-600 font-rocGroteskMedium text-[13px] flex items-center gap-2
                      border-b border-b-slate-100 !w-[190px] px-4 py-[10px]"
            >
                1 month
            </div>
        ),
        value: moment().add(1, "months").format("YYYY-MM-DD"),
    },
    {
        label: (
            <div
                className=" text-slate-600 font-rocGroteskMedium text-[13px] flex items-center gap-2
                      border-b border-b-slate-100 !w-[190px] px-4 py-[10px]"
            >
                2 months
            </div>
        ),
        value: moment().add(2, "months").format("YYYY-MM-DD"),
    },
    {
        label: (
            <div
                className=" text-slate-600 font-rocGroteskMedium text-[13px] flex items-center gap-2
                      border-b border-b-slate-100 !w-[190px] px-4 py-[10px]"
            >
                3 months
            </div>
        ),
        value: moment().add(3, "months").format("YYYY-MM-DD"),
    },
    {
        label: (
            <div
                className=" text-slate-600 font-rocGroteskMedium text-[13px] flex items-center gap-2
                      border-b border-b-slate-100 !w-[190px] px-4 py-[10px]"
            >
                4 months
            </div>
        ),
        value: moment().add(4, "months").format("YYYY-MM-DD"),
    },
    {
        label: (
            <div
                className=" text-slate-600 font-rocGroteskMedium text-[13px] flex items-center gap-2
                      border-b border-b-slate-100 !w-[190px] px-4 py-[10px]"
            >
                5 months
            </div>
        ),
        value: moment().add(5, "months").format("YYYY-MM-DD"),
    },
    {
        label: (
            <div
                className=" text-slate-600 font-rocGroteskMedium text-[13px] flex items-center gap-2
                      border-b border-b-slate-100 !w-[190px] px-4 py-[10px]"
            >
                6 months
            </div>
        ),
        value: moment().add(6, "months").format("YYYY-MM-DD"),
    },
];
